<template>
    <div>
      <TransitionRoot appear :show="isMessageOpen" @close="closeMessageModal" as="template">
        <Dialog as="div">
          <div class="fixed inset-0 z-10 overflow-y-auto">
            <div class="min-h-screen px-4 text-center">
              <TransitionChild
                as="template"
                enter="duration-300 ease-out"
                enter-from="opacity-0"
                enter-to="opacity-100"
                leave="duration-200 ease-in"
                leave-from="opacity-100"
                leave-to="opacity-0"
              >
                <DialogOverlay class="fixed inset-0 bg-black opacity-70" />
              </TransitionChild>
  
              <span class="inline-block h-screen align-middle" aria-hidden="true">
                &#8203;
              </span>
  
              <TransitionChild
                as="template"
                enter="duration-300 ease-out"
                enter-from="opacity-0 scale-95"
                enter-to="opacity-100 scale-100"
                leave="duration-200 ease-in"
                leave-from="opacity-100 scale-100"
                leave-to="opacity-0 scale-95"
              >
                <div
                  class="inline-block border w-full max-w-4xl p-6 my-6 overflow-hidden text-left align-middle transition-all transform bg-white shadow-2xl"
                >
                  <DialogTitle
                    as="h6"
                    :class=" isOk ? 'text-size-md font-medium leading-6 text-emerald-500' : 'text-size-md font-medium leading-6 text-gray-500'"
                  >
                    {{ title }} 
                    <span v-if="errorMessage !== ''" class=" text-red-500">
                      ({{ errorMessage }})
                    </span>
                  </DialogTitle>
                  <div class="my-1 space-y-6">
                      <table  id="datatable" class="table-auto w-full shadow-md cursor-pointer">
                          <thead>
                            <tr class="bg-emerald-600 text-size-xs pointer-events-none" style="">
                              <td class="py-2.5 px-2 text-left text-white font-bold">Goal</td>
                              <td class="py-2.5 px-2 text-left text-white font-bold">Percentage Achieved</td>
                              <td class="py-2.5 px-2 text-left text-white font-bold">Supervisor Percentage</td>
                            </tr>
                          </thead>
                          <tbody>
                            <!-- ommit the totals last row -->
                            <tr v-for="(data, i) in reportData" :key="i" class=" text-gray-600 text-size-sm" style="">
                              <td class="py-2.5 px-2 border text-left font-medium">{{ data.goal }}</td>
                              <td class="py-2.5 px-2 border text-left">{{ data.percentageAchieved }}</td>
                              <td 
                                v-if="data.goal !== 'Total'"
                                class="py-2.5 px-2 border text-left">
                                <!-- {{ data }} -->
                                <input
                                  :id="data.goal"
                                  v-model="data.supervisorScore"
                                  placeholder="Percentage"
                                  required
                                  @keyup="changed()"
                                  type="number"
                                  min="0"
                                  max="100"
                                  class="bg-gray-50 text-size shadow-sm text-gray-600 w-full border px-2 py-2 border-gray-300 focus:outline-none focus:border-emerald-600 focus:ring-1 focus:ring-emerald-600"/> 
                              </td>
                              <td v-else class="py-2.5 px-2 border text-left">
                                {{ data.supervisorScore }}
                              </td>
                            </tr>
                          </tbody>
                      </table>

                      <!-- the observations -->
                      <div class=" space-y-2">
                        <label for="email" class="block text-size-md font-medium text-gray-500 text-left">Supervisor's observation about the incomplete percentage</label>
                        <div>
                          <textarea
                            rows="6"
                            v-model="observations"
                            placeholder="Supervisor's observation about the incomplete percentage"
                            class="bg-gray-50 text-size-md shadow-md text-gray-600 w-full border px-2 py-3 border-gray-300 focus:outline-none focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500"/>
                        </div>
                      </div>
                  </div>
  
                  <div class="mt-2 flex justify-center">
                    <button
                      type="button"
                      class=" items-center inline-flex justify-center px-4 py-1 text-size text-emerald-900 bg-gray-300 border
                              border-transparent hover:bg-red-500 hover:opacity-90 hover:text-white focus:outline-none focus-visible:ring-2
                              focus-visible:ring-offset-2 focus-visible:ring-white"
                      @click="submit()"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </TransitionChild>
            </div>
          </div>
        </Dialog>
      </TransitionRoot>
    </div>
  </template>
  
  <script>
  import { ref } from 'vue'
  import { TransitionRoot, TransitionChild, Dialog, DialogOverlay } from '@headlessui/vue'
  
  export default {
    components: {
      TransitionRoot,
      TransitionChild,
      Dialog,
      DialogOverlay
      // DialogTitle
    },
    setup () {
      const isMessageOpen = ref(false)
      return {
        isMessageOpen,
        closeMessageModal () {
          isMessageOpen.value = false
        },
        openMessageModal () {
          isMessageOpen.value = true
        }
      }
    },
    name: 'feedback-modal',
    props: {
      isOk: Boolean,
      title: String,
      message: String
    },
    data: () => {
      return {
        feedback: '',
        reportData: [],
        errorMessage: '',
        observations: ''
      }
    },
    methods: {
      checkScores () {
        // check if any of the scores is less thaan 0 || greater thaan 100 || its null || undefined
        const size = (this.reportData.length - 1)

        for (let i = 0; i < size; i++) {
          const data = this.reportData[i]
          
          // supervisor score
          const score = data.supervisorScore
          
          if (typeof(score) !== 'number' || isNaN(score) || parseFloat(score) < 0 || parseFloat(score) > 100) {
            return false
          }
          
        }

        return true
      },
      changed () {
        // reset the message
        this.errorMessage = ''

        // get the data from the table
        const size = (this.reportData.length - 1)
        let total = 0

        for (let i = 0; i < size; i++) {
          const data = this.reportData[i]
          const id = data.goal
          const element = document.getElementById(id)
          const value = element.value

          if (value !== null && value !== null && value.trim() !== '' && !isNaN(value)) {

            if (value < 0 || value > 100) {
              this.errorMessage = 'The supervisor percentage cannot be below 0 or exceed 100.'
              break
            }

            const amount = parseFloat(value)
            this.reportData.supervisorScore = amount

            total += amount
          }

        }

        this.reportData[size].supervisorScore = total
      },
      setReportData (data) {
        this.reportData = data
      },
      submit () {
        if (this.checkScores()) {
          // send the feedback & close the modal
          this.emitEvent()
          this.closeMessageModal()
        }
      },
      emitEvent () {
        const data = { data: this.reportData, observations: this.observations }
        this.$emit('submit', data)
      },
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style >
  </style>
  